import { Flex, Icon, Text } from "@capioweb/ui-components/src"
import React from "react"
import { SiteSearchFilterContext } from "../../pages/SiteSearchPage/context"
import { PaginationButton } from "./components/PaginationButton"
import { PaginationContext } from "./context/PaginationContext"
import { PaginationBlockProps } from './PaginationBlockDesktop'

const PaginationBlockMobile: React.FC<PaginationBlockProps> = ({ onClickHandler }) => {
	const { activePage, setActivePage } = React.useContext(PaginationContext)
	const { activeItems } = React.useContext(SiteSearchFilterContext)
	const totalPages = Math.ceil(activeItems.length / 10)

	const showPrevPageBtn = Number(activePage) > 1
	const showNextPageBtn = Number(activePage) < totalPages

	const getPagesToDisplay = (activePage: number, totalPages: number) => {
		let start = Number(activePage) === 1 ? 1 : Number(activePage) - 1

		if (totalPages - Number(activePage) < 1) start = totalPages - 2

		return Array.from({ length: totalPages + 1 }, (x, i) => i).slice(
			start,
			start + 3
		)
	}

	const filteredPages =
		totalPages < 3
			? Array.from({ length: totalPages }, (x, i) => i)
			: getPagesToDisplay(Number(activePage), totalPages)

	if (totalPages <= 1) return <></>

	return (
		<Flex
			maxw={62}
			columnGap={1}
			justifyContent="center"
			m="auto"
			display={{ _: "flex", m: "none" }}
		>
			{/* Previous page button*/}
			{showPrevPageBtn && (
				<PaginationButton
					ariaLabel="Previous page"
					onclick={() => {
						setActivePage((Number(activePage) - 1).toString())
						onClickHandler()
					}}
				>
					<Flex m="auto">
						<Icon icon="chevron-left" m="auto" />
					</Flex>
				</PaginationButton>
			)}
			{totalPages > 2 ? (
				<>
					{filteredPages.map((i: number) => {
						return (
							<PaginationButton
								key={i}
								bgColor={Number(activePage) === i}
								onclick={() => {
									setActivePage(i.toString())
									onClickHandler()
								}}
							>
								<Text m="auto" textAlign="center">
									{i}
								</Text>
							</PaginationButton>
						)
					})}
				</>
			) : (
				<>
					{Array.from({ length: totalPages }, (x, i) => i).map((i: number) => {
						return (
							<PaginationButton
								key={i}
								bgColor={Number(activePage) === i + 1}
								onclick={() => {
									setActivePage((i + 1).toString())
									onClickHandler()
								}}
							>
								<Text m="auto" textAlign="center">
									{i + 1}
								</Text>
							</PaginationButton>
						)
					})}
				</>
			)}
			{/* Next page button*/}
			{showNextPageBtn && (
				<PaginationButton
					ariaLabel="Next page"
					onclick={() => {
						setActivePage((Number(activePage) + 1).toString())
						onClickHandler()
					}}
				>
					<Flex m="auto">
						<Icon icon="chevron-right" m="auto" />
					</Flex>
				</PaginationButton>
			)}
		</Flex>
	)
}

export { PaginationBlockMobile }
